import { useMatch } from 'react-router';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import InternalErrorState from '@/features/app/InternalErrorState';
import { useFetchPackHistoryQuery } from '@/features/battery/api/batterySlice';
import PackHistoryDialog from '@/features/battery/workshop/PackHistoryDialog';
import { LoadingScreen } from '@/features/batteryOverview/utils/BatteryDataUtils';

const PackHistoryPage = () => {
    const assetId = useMatch('/dialog/pack-history/:assetId')?.params.assetId;
    const { isLoading, isError, error, data: packHistory, refetch } = useFetchPackHistoryQuery(assetId!);

    if (isLoading) {
        return <LoadingScreen />;
    }
    if (isError) {
        return (
            <InternalErrorState
                errorCode={(error as FetchBaseQueryError).status as number}
                reloadTriggerFunction={refetch}
            />
        );
    }

    if (!packHistory) {
        return null;
    }

    return <PackHistoryDialog packHistory={packHistory} />;
};

export default PackHistoryPage;
